import { Listeners } from './utils.js';

class CosTabs extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.tabs = this.querySelectorAll('cos-tab');
    this.variantTabs = this.querySelectorAll('[data-variant-id]');

    // add custom event to listen for tab change
    this.listeners.add(window, 'variant.change', (event) => {
      // this.changeTab(event.detail.index);
      this.changeTabByVariantId(event.detail.variantId);
    });

    document.querySelectorAll(`[data-open-tab="${this.dataset.id}"]`).forEach((tab) => {
      if (!tab.dataset.index) return;

      this.listeners.add(tab, 'click', () => {
        this.changeTab(parseInt(tab.dataset.index));
      });
    });
  }

  disconnectedCallback() {
    if (this.listeners) {
      this.listeners.removeAll();
    }
  }

  changeTab(index) {
    this.tabs.forEach((tab, i) => {
      if (i === index) {
        this.showTab(tab);
      } else {
        this.hideTab(tab);
      }
    });
  }

  changeTabByVariantId(variantId) {
    this.variantTabs.forEach((tab) => {
      if (tab.dataset.variantId === variantId?.toString()) {
        this.showTab(tab);
      } else {
        this.hideTab(tab);
      }
    });
  }

  showTab(tab) {
    tab.inert = false;
    
    // const cosSlider = tab.querySelector('cos-flickity');
    // if (!cosSlider) return;

    // cosSlider.updateSlider();
  }

  hideTab(tab) {
    tab.inert = true;
  }
}
if (!customElements.get('cos-tabs'))  customElements.define('cos-tabs', CosTabs);

class CosTabsControls extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.controls = this.querySelectorAll('button');
    this.tabs = document.querySelectorAll(`[data-id=${this.dataset.controls}]`);

    this.controls.forEach((control, index) => {
      this.listeners.add(control, 'click', () => {
        this.changeTab(control, index);
      });
    });
  }

  disconnectedCallback() {
    if (this.listeners) {
      this.listeners.removeAll();
    }
  }

  changeTab(control, index) {
    this.resetActive();
    this.tabs.forEach((tab) => {
      tab.changeTab(index);
    });
    control.classList.add('active');
  }

  resetActive() {
    this.controls.forEach((control) => {
      control.classList.remove('active');
    });
  }
}
if (!customElements.get('cos-tabs-controls'))  customElements.define('cos-tabs-controls', CosTabsControls);